import { GridFilterItem, GridFilterModel, GridLogicOperator } from '@mui/x-data-grid-premium'
import { z } from 'zod'

// Types based on mui-data-grid-premium
// We shouldn't import from the package directly because if they update the
// package, the new types won't reflect what is already stored in the DB

const FilterItemSchema = z.object({
  id: z.union([z.number(), z.string()]),
  field: z.string(),
  value: z.union([z.string(), z.number(), z.array(z.string())]).optional(),
  operator: z.string(),
})

export type FilterItem = z.infer<typeof FilterItemSchema>

export const FilterModelSchema = z.object({
  items: z.array(FilterItemSchema),
  logicOperator: z.nativeEnum(GridLogicOperator).optional(),
  quickFilterValues: z.array(z.unknown()).optional(),
  quickFilterLogicOperator: z.nativeEnum(GridLogicOperator).optional(),
  quickFilterExcludeHiddenColumns: z.boolean().optional(),
})

export type FilterModel = z.infer<typeof FilterModelSchema>

export const validateFilterModel = (filterModel: GridFilterModel | undefined | null) => {
  if (!filterModel || filterModel.items.length === 0) return 'empty' as const
  if (!filterModel.items.every(filterItemIsValid)) return 'incomplete' as const

  return undefined
}

export const filterItemIsValid = (filterItem: GridFilterItem): filterItem is FilterItem => {
  if (filterItem.operator === 'isEmpty' || filterItem.operator === 'isNotEmpty') {
    return true
  }

  if (typeof filterItem.value === 'number') return true

  const trimmedValue = trimIfString(filterItem.value)
  return !!trimmedValue
}

const trimIfString = (value: unknown) => (typeof value === 'string' ? value.trim() : value)
